import { RoutingPathsType } from '../../../features/dashboards/admin/helpers/routing';
import { WithEvaluationRun, WithRevision } from '../../../features/dashboards/admin/sections/assistants/types/AssistantsServiceTypes';
import { delimit } from '../../../helpers/listsHelpers';

export const AdminQueryKeys = {
    all: 'admin',

    permission: () => [AdminQueryKeys.all, 'permission'],
    definitions: () => [AdminQueryKeys.all, 'definitions'],
    assistants: () => [AdminQueryKeys.all, 'assistants'],
    assistant: ({ assistantId }: RoutingPathsType['assistant']) => [AdminQueryKeys.all, 'assistant', assistantId],
    assistantAssetImage: ({ assistantId }: RoutingPathsType['assistant']) => [AdminQueryKeys.all, 'assistant-asset-image', assistantId],
    assistantVersions: ({ assistantId }: RoutingPathsType['assistant']) => [AdminQueryKeys.all, 'versions', assistantId],
    assistantVersion: ({ assistantId, versionNumber }: RoutingPathsType['versions']) => [AdminQueryKeys.all, 'versions', assistantId, versionNumber],
    assistantVersionFiles: ({ assistantId, versionNumber }: RoutingPathsType['versions']) => [AdminQueryKeys.all, 'assistant-version-files', assistantId, versionNumber],
    assistantVersionRevision: ({ assistantId, versionNumber, revisionKey }: RoutingPathsType['versions'] & WithRevision) => [AdminQueryKeys.all, 'revision', assistantId, versionNumber, revisionKey?.toString()],

    assistantEvaluate: ({ assistantId }: RoutingPathsType['evaluate']) => [AdminQueryKeys.all, assistantId, 'evaluate'],
    assistantEvaluationCollection: ({ assistantId, evaluationKey }: RoutingPathsType['evaluationCollection']) => [AdminQueryKeys.all, assistantId, 'evaluate', evaluationKey],
    assistantEvaluationRuns: ({ assistantId }: RoutingPathsType['evaluate']) => [AdminQueryKeys.all, assistantId, 'runs'],
    assistantEvaluationRun: ({ assistantId, evaluationRunKey }: RoutingPathsType['evaluate'] & WithEvaluationRun) => [AdminQueryKeys.all, assistantId, 'evaluation-run', evaluationRunKey || '-'],
    evaluationLevels: () => [AdminQueryKeys.all, 'evaluation-levels'],

    // Admin Assistants
    audience: ({ user, group, role, app, danfoss_app }: { user: string[], group: string[], role: string[], app: string[], danfoss_app: string[]; }) => [AdminQueryKeys.all, 'audience', delimit(user), delimit(group), delimit(role), delimit(app), delimit(danfoss_app)],
    audienceSearch: ({ type, keyword = '', top }: { type: string, keyword?: string; top?: number; }) => [AdminQueryKeys.all, 'audience-search', top, type, keyword],

    // Admin Models
    models: () => [AdminQueryKeys.all, 'models'],
    model: ({ modelId }: RoutingPathsType['model']) => [AdminQueryKeys.all, 'model', modelId],

    // Admin Tools
    tools: () => [AdminQueryKeys.all, 'tools'],
    tool: ({ toolId }: RoutingPathsType['tool']) => [AdminQueryKeys.all, 'tool', toolId],
};
